import { KYMW0A00Model } from '../kymw0a00.model';
import { MembersVoiceInputDataModel } from '../vo/members-voice-input-data.model';
import { PublishVoiceDataModel } from '../vo/publish-voice-data.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 組合員の声掲載情報を登録するサービス
 *
 * @export RegistPublishVoiceDataService
 * @class RegistPublishVoiceDataService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistPublishVoiceDataService extends PlessJsonResponderSub<any> {
  private model: KYMW0A00Model = null;
  private vo: PublishVoiceDataModel;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistPublishVoiceDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ReceiptNum: this.vo.receiptNum,
        CoopCode: this.vo.coopCode,
        OrderCode: this.vo.orderCode,
        Pcode: this.vo.pcode,
        OrderGoodsFlg: this.vo.orderGoodsFlg,
        ReceiptSOrderCode: this.vo.receiptSOrderCode,
        OrderNum6Digits: this.vo.orderNum6Digits,
        ItemCode: this.vo.itemCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model KYMW0A00Model
   * @memberof RegistPublishVoiceDataService
   */
  execute(model: KYMW0A00Model, vo: PublishVoiceDataModel, successFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('registPublishVoiceData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistPublishVoiceDataService
   */
  success(data: any): void {
    this.successFunc();
  }
}
